import newFile from "./states/newFile.state";
import estados from "./states/estados.state";

const model = {
    newFile,
    estados,
};

export default model;
